import { render, staticRenderFns } from "./catalog-edit-page.vue?vue&type=template&id=3b7a6256&"
import script from "./catalog-edit-page.vue?vue&type=script&lang=ts&"
export * from "./catalog-edit-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports